import {VcDateUtils} from './vcdateutils';
import { VcListUtils } from './vclistutils';
export var QueryCostCalculator = (function () {
    


    return {
      calculate: function(queryDefinition) {
        const resolvedDateRange = VcDateUtils.resolveDateRange(queryDefinition.startdate, queryDefinition.enddate);
        const startDate = resolvedDateRange[0];
        let endDate = resolvedDateRange[1];
        if (startDate && !endDate) {
          endDate = startDate;
        }

        if (!startDate || !endDate) {
          return {error: "Invalid date range"};
        }
        let values=VcListUtils.valuesInList(queryDefinition.include)
        if (values)  {
          values = values.reduce(function(a, d) {
            if (VcListUtils.CSVINCLUDESIDS.indexOf(d)!==-1) a.push(d);
            return a;
          }, []);

        }

        let hasDays = !values || values.indexOf("days") !== -1;
        let hasHours = !values || values.indexOf("hours") !== -1;
        let hasMinutes = values && values.indexOf("minutes") !== -1;
        //let hasEvents = values && values.indexOf("events") !== -1;
        
        if (!values || values.length === 0) {
          hasDays = true;
          hasHours = true;
          hasMinutes = false;
        } else if (!hasDays && !hasHours && !hasMinutes) {
          hasDays = true;
          //hasHours = true; // Default to hours if no specific granularity is selected
        }
        
        const minuteInterval = VcListUtils.getIntValueInList(queryDefinition.options, "minuteinterval", 15);
        
        const totalDays = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24)) + 1;
        let totalHours = totalDays * 24;
        let totalMinutes = Math.ceil(totalHours * 60 / minuteInterval);
        
        const forecastDays = 15;
        
        // Calculate free forecast date range
        const today = new Date();
        today.setHours(0, 0, 0, 0); // Set to start of day
        
        const forecastEndDate = new Date(today);
        forecastEndDate.setDate(today.getDate() + forecastDays);
        forecastEndDate.setHours(23, 59, 59, 999); // Set to end of day
        
        // Calculate how many days in the query range fall within the free forecast period
        let forecastDaysUsed = 0;
    
        
        // Find the overlap between query range and free forecast range
        const queryStartDate = new Date(startDate);
        const queryEndDate = new Date(endDate);
        
        // Check if there's any overlap
        if (queryEndDate >= today && queryStartDate <= forecastEndDate) {
          // Calculate the overlapping period
          const overlapStart = new Date(Math.max(queryStartDate.getTime(), today.getTime()));
          const overlapEnd = new Date(Math.min(queryEndDate.getTime(), forecastEndDate.getTime()));
          
          // Calculate days in overlap (inclusive)
          forecastDaysUsed = Math.ceil((overlapEnd - overlapStart) / (1000 * 60 * 60 * 24)) + 1;
        }
        
        // Calculate paid days (days outside the free forecast period)
        const paidDaysUsed = Math.max(1, totalDays - forecastDaysUsed);
        
        // Calculate detailed breakdown
        const forecastHoursUsed = forecastDaysUsed * 24;
        const paidHoursUsed = Math.max(1, totalHours - forecastHoursUsed);
        const paidMinutesUsed = totalMinutes;


        let estimatedCost = 1;
        if (hasMinutes) {
          estimatedCost = paidMinutesUsed; 
        } else if (hasHours) {
          estimatedCost = paidHoursUsed; 
        } else {
          estimatedCost = paidDaysUsed; 
        }
        estimatedCost=Math.max(1, estimatedCost);

        // Return cost calculation result
        return {
          estimatedCost: estimatedCost,
          totalDays: totalDays,
          totalHours: totalHours,
          totalMinutes: totalMinutes,
          forecastDaysUsed: forecastDaysUsed,
          paidDaysUsed: paidDaysUsed,
          forecastHoursUsed: hasHours ? forecastHoursUsed : 0,
          paidHoursUsed: hasHours ? paidHoursUsed : 0,
          paidMinutesUsed: hasMinutes ? paidMinutesUsed : 0,
          minuteInterval: minuteInterval,
          forecastStartDate: today,
          forecastEndDate: forecastEndDate,
          queryStartDate: queryStartDate,
          queryEndDate: queryEndDate,
          hasDays: hasDays,
          hasHours: hasHours,
          hasMinutes: hasMinutes
        };
      }
    }

}());
    
